<!-- Sales mode -->
<ion-grid class="ion-no-padding" *ngIf="viewSetting === 'sales'">
    <!-- Header Row -->
    <ion-row>
        <ion-col class="ion-no-padding"></ion-col>
        <ion-col class="ion-no-padding">
            <span class="property-snapshot-analysis--bold" *ngIf="property.get('type') === 'rental/flip'">Rental</span>
            <span class="property-snapshot-analysis--bold" *ngIf="property.get('type') === 'rental'">Cash</span>
            <span class="property-snapshot-analysis--bold" *ngIf="property.get('type') === 'flip'">Cash</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span class="property-snapshot-analysis--bold" *ngIf="property.get('type') === 'rental/flip'">Flip</span>
            <span class="property-snapshot-analysis--bold" *ngIf="property.get('type') === 'rental'">Finance</span>
            <span class="property-snapshot-analysis--bold" *ngIf="property.get('type') === 'flip'">Finance</span>
        </ion-col>
    </ion-row>

    <!-- Price Row -->
    <ion-row>
        <ion-col class="ion-no-padding">Price:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getPurchasePrice(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getPurchasePrice(property, 'right') }}</span>
        </ion-col>
    </ion-row>

    <!-- ARV Row -->
    <ion-row>
        <ion-col class="ion-no-padding">ARV:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getARV(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getARV(property, 'right') }}</span>
        </ion-col>
    </ion-row>

    <!-- Rehab Row -->
    <ion-row>
        <ion-col class="ion-no-padding">Rehab:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getRehabWord(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getRehabWord(property, 'right') }}</span>
        </ion-col>
    </ion-row>

    <!-- ROI Row -->
    <ion-row>
        <ion-col class="ion-no-padding">ROI:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getROI(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getROI(property, 'right') }}</span>
        </ion-col>
    </ion-row>

    <!-- Net Income Row -->
    <ion-row *ngIf="property.get('type') !== 'rental/flip'">
        <ion-col class="ion-no-padding">Net Income:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'right') }}</span>
        </ion-col>
    </ion-row>
    <ion-row *ngIf="property.get('type') === 'rental/flip'">
        <ion-col class="ion-no-padding">Equity:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'right') }}</span>
        </ion-col>
    </ion-row>
</ion-grid>

<!-- Acquisition mode -->
<ion-grid class="ion-no-padding" *ngIf="viewSetting === 'acquisition'">
    <!-- Header Row -->
    <ion-row>
        <ion-col class="ion-no-padding"></ion-col>
        <ion-col class="ion-no-padding">
            <span class="property-snapshot-analysis--bold">Rental</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span class="property-snapshot-analysis--bold">Flip</span>
        </ion-col>
    </ion-row>

    <!-- Offer Row -->
    <ion-row>
        <ion-col class="ion-no-padding">Offer:</ion-col>
        <ion-col class="ion-no-padding">
            <span *ngIf="property.get('offerRental').get('offerPrice')">
                {{ property.get('offerRental').get('offerPrice') | currency:'USD':'symbol':'1.0-0' }}
            </span>
            <span *ngIf="!property.get('offerRental').get('offerPrice')">
                N/A
            </span>
        </ion-col>
        <ion-col class="ion-no-padding">
             <span *ngIf="property.get('offerFlip').get('offerPrice')">
                {{ property.get('offerFlip').get('offerPrice') | currency:'USD':'symbol':'1.0-0' }}
            </span>
            <span *ngIf="!property.get('offerFlip').get('offerPrice')">
                N/A
            </span>
        </ion-col>
    </ion-row>

    <!-- ARV Row -->
    <ion-row>
        <ion-col class="ion-no-padding">ARV:</ion-col>
        <ion-col class="ion-no-padding">
            <span *ngIf="property.get('offerRental').get('arv')">
                {{ property.get('offerRental').get('arv') | currency:'USD':'symbol':'1.0-0' }}
            </span>
            <span *ngIf="!property.get('offerRental').get('arv')">
                N/A
            </span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span *ngIf="property.get('offerFlip').get('arv')">
                {{ property.get('offerFlip').get('arv') | currency:'USD':'symbol':'1.0-0' }}
            </span>
            <span *ngIf="!property.get('offerFlip').get('arv')">
                N/A
            </span>
        </ion-col>
    </ion-row>

    <!-- Rehab Row -->
    <ion-row>
        <ion-col class="ion-no-padding">Rehab:</ion-col>
        <ion-col class="ion-no-padding">
            <span *ngIf="property.get('offerRental').get('renoCost') || property.get('offerRental').get('renoCost') === 0 ">
                {{ property.get('offerRental').get('renoCost') | currency:'USD':'symbol':'1.0-0' }}
            </span>
            <span *ngIf="!property.get('offerRental').get('renoCost') && property.get('offerRental').get('renoCost') !== 0">
                N/A
            </span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span *ngIf="property.get('offerFlip').get('renoCost') || property.get('offerFlip').get('renoCost') === 0">
                {{ property.get('offerFlip').get('renoCost') | currency:'USD':'symbol':'1.0-0' }}
            </span>
            <span *ngIf="!property.get('offerFlip').get('renoCost') && property.get('offerFlip').get('renoCost') !== 0">
                N/A
            </span>
        </ion-col>
    </ion-row>

    <!-- ROI Row -->
    <ion-row>
        <ion-col class="ion-no-padding">ROI:</ion-col>
        <ion-col class="ion-no-padding">
            <span *ngIf="property.get('aaRental').get('roi')">
                {{ property.get('aaRental').get('roi') | percent:'1.0-2' }}
            </span>
            <span *ngIf="!property.get('aaRental').get('roi')">
                N/A
            </span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span *ngIf="property.get('aaFlip').get('roi')">
                {{ property.get('aaFlip').get('roi') | percent:'1.0-2' }}
            </span>
            <span *ngIf="!property.get('aaFlip').get('roi')">
                N/A
            </span>
        </ion-col>
    </ion-row>

    <!-- Net Income Row -->
    <ion-row *ngIf="property.get('type') !== 'rental/flip'">
        <ion-col class="ion-no-padding">Net Income:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'right') }}</span>
        </ion-col>
    </ion-row>
    <ion-row *ngIf="property.get('type') === 'rental/flip'">
        <ion-col class="ion-no-padding">Equity:</ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'left') }}</span>
        </ion-col>
        <ion-col class="ion-no-padding">
            <span>{{ propertyAnalysis.getNetIncome(property, 'right') }}</span>
        </ion-col>
    </ion-row>
</ion-grid>


